import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Terms of Service - WorkNation Labour Ltd</title>
        <meta name="description" content="Terms of service for WorkNation Labour Ltd. Read our terms governing the use of our staffing services and website." />
        <link rel="canonical" href="https://worknation.ca/terms-of-service" />
      </Helmet>
      <Header />
      <main className="pt-32 pb-20 px-6">
        <article className="max-w-4xl mx-auto prose prose-lg prose-slate">
          <h1 className="text-4xl font-bold text-[#003366] mb-2">Terms of Service</h1>
          <p className="text-gray-500 mb-8">Last updated: {new Date().toLocaleDateString('en-CA', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

          <p className="text-gray-700 leading-relaxed">
            These Terms of Service (&ldquo;Terms&rdquo;) govern your use of the WorkNation Labour Ltd website and staffing services. By accessing or using our services, you agree to be bound by these Terms.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-10 mb-4">1. Services</h2>
          <p className="text-gray-700">
            WorkNation Labour Ltd provides temporary, contract, and permanent staffing services across British Columbia. Our services include sourcing, screening, and placing workers with employer clients, as well as payroll administration and WCB compliance management.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-10 mb-4">2. Employer Responsibilities</h2>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Provide accurate job descriptions and workplace requirements.</li>
            <li>Maintain a safe working environment in compliance with WorkSafe BC standards.</li>
            <li>Supervise and direct the day-to-day activities of placed workers.</li>
            <li>Pay invoices in accordance with agreed-upon payment terms.</li>
            <li>Not hire or solicit WorkNation workers directly without prior agreement.</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#003366] mt-10 mb-4">3. Worker Responsibilities</h2>
          <ul className="list-disc pl-6 text-gray-700 space-y-2">
            <li>Provide accurate information regarding qualifications, experience, and certifications.</li>
            <li>Arrive on time and prepared for assigned work.</li>
            <li>Follow all workplace safety protocols and employer instructions.</li>
            <li>Notify WorkNation immediately of any workplace incidents, injuries, or concerns.</li>
            <li>Maintain professional conduct at all times while on assignment.</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#003366] mt-10 mb-4">4. Payment Terms</h2>
          <p className="text-gray-700">
            Employer clients are invoiced for staffing services at the agreed-upon rates. Payment terms are as specified in individual service agreements. Late payments may be subject to interest charges as permitted by British Columbia law.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-10 mb-4">5. Limitation of Liability</h2>
          <p className="text-gray-700">
            WorkNation Labour Ltd exercises reasonable care in screening and selecting workers. However, we do not guarantee the performance of any individual worker. Our liability is limited to the fees charged for the specific staffing service in question. We are not liable for indirect, consequential, or incidental damages.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-10 mb-4">6. Temp-to-Perm Conversions</h2>
          <p className="text-gray-700">
            If an employer wishes to hire a WorkNation worker on a permanent basis, a conversion fee may apply as specified in the service agreement. Workers must complete a minimum assignment period before conversion eligibility.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-10 mb-4">7. Confidentiality</h2>
          <p className="text-gray-700">
            Both parties agree to maintain the confidentiality of all proprietary information shared during the course of the staffing relationship, including business plans, rates, and worker information.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-10 mb-4">8. Website Use</h2>
          <p className="text-gray-700">
            You may use our website for its intended purpose of learning about our services and contacting us. You may not scrape, copy, or reproduce content without written permission. All content on this website is the property of WorkNation Labour Ltd.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-10 mb-4">9. Governing Law</h2>
          <p className="text-gray-700">
            These Terms are governed by the laws of British Columbia, Canada. Any disputes arising from these Terms shall be resolved in the courts of British Columbia.
          </p>

          <h2 className="text-2xl font-bold text-[#003366] mt-10 mb-4">10. Contact</h2>
          <p className="text-gray-700">
            For questions about these Terms, contact us at <a href="mailto:info@worknation.ca" className="text-[#003366] hover:underline">info@worknation.ca</a>.
          </p>
        </article>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfServicePage;
